<script>
  import Lazy from "svelte-lazy";
</script>

<div class="mx-auto" >
  <div class="h-30 flex flex-col justify-left items-left mt-[5rem] md:mt-[130px] mb-5">
    <p
      class="text-[20px] md:text-[24px] lg:text-[30px] font-[600] text-primary text-center mb-4">
      Features
    </p>
    <h1 class="text-center text-black font-[600] text-[24px] md:text-[30px]">
      Uncover Seamless Accessibility
    </h1>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
    <div class="hidden md:flex flex-col justify-center items-center">
      <Lazy height={300}>
        <picture>
          <img
            sizes="(max-width: 1400px) 100vw, 1400px"
            srcset="features1_fq0pyu_c_scale,w_1400.png"
            src="features1_fq0pyu_c_scale,w_1400.png"
            alt="Gambar"
            class="object-contain community-object xl:max-w-[670px] lg::max-w-[472px] h-[32rem] my-12"
            width="697px"
            height="596px"
            loading="eager"
          />
        </picture>
      </Lazy>
    </div>
    <div class="flex flex-col justify-center"
    style="margin-left: 2rem">
      <button
        class="btn btn-info btn-sm md:btn-md mb-5 w-[15rem] md:w-66 gap-2 font-[500] text-primary">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.99996 1.66666C14.6025 1.66666 18.3333 5.39749 18.3333 9.99999C18.3333 14.6025 14.6025 18.3333 9.99996 18.3333C5.39746 18.3333 1.66663 14.6025 1.66663 9.99999C1.66663 5.39749 5.39746 1.66666 9.99996 1.66666ZM13.83 6.16999C13.7474 6.08746 13.6385 6.03662 13.5222 6.02641C13.4059 6.0162 13.2898 6.04727 13.1941 6.11416C10.7858 7.80416 9.42746 8.80582 9.11579 9.11582C8.8813 9.35032 8.74956 9.66836 8.74956 9.99999C8.74956 10.3316 8.8813 10.6497 9.11579 10.8842C9.35029 11.1187 9.66833 11.2504 9.99996 11.2504C10.3316 11.2504 10.6496 11.1187 10.8841 10.8842C11.0666 10.7008 12.0658 9.34166 13.8825 6.80332C13.9501 6.70862 13.9819 6.593 13.9723 6.47703C13.9627 6.36107 13.9122 6.25227 13.83 6.16999ZM14.5833 9.16666C14.3623 9.16666 14.1503 9.25445 13.994 9.41073C13.8378 9.56702 13.75 9.77898 13.75 9.99999C13.75 10.221 13.8378 10.433 13.994 10.5892C14.1503 10.7455 14.3623 10.8333 14.5833 10.8333C14.8043 10.8333 15.0163 10.7455 15.1725 10.5892C15.3288 10.433 15.4166 10.221 15.4166 9.99999C15.4166 9.77898 15.3288 9.56702 15.1725 9.41073C15.0163 9.25445 14.8043 9.16666 14.5833 9.16666ZM5.41663 9.16666C5.19561 9.16666 4.98365 9.25445 4.82737 9.41073C4.67109 9.56702 4.58329 9.77898 4.58329 9.99999C4.58329 10.221 4.67109 10.433 4.82737 10.5892C4.98365 10.7455 5.19561 10.8333 5.41663 10.8333C5.63764 10.8333 5.8496 10.7455 6.00588 10.5892C6.16216 10.433 6.24996 10.221 6.24996 9.99999C6.24996 9.77898 6.16216 9.56702 6.00588 9.41073C5.8496 9.25445 5.63764 9.16666 5.41663 9.16666ZM7.34829 6.16999C7.27142 6.0904 7.17947 6.02691 7.0778 5.98324C6.97613 5.93956 6.86678 5.91658 6.75613 5.91561C6.64548 5.91465 6.53574 5.93574 6.43333 5.97764C6.33092 6.01954 6.23787 6.08142 6.15963 6.15966C6.08139 6.2379 6.01951 6.33095 5.97761 6.43336C5.93571 6.53578 5.91462 6.64551 5.91558 6.75616C5.91655 6.86681 5.93953 6.97616 5.98321 7.07783C6.02688 7.1795 6.09037 7.27145 6.16996 7.34832C6.32713 7.50012 6.53763 7.58412 6.75613 7.58222C6.97462 7.58032 7.18363 7.49268 7.33814 7.33817C7.49265 7.18367 7.58029 6.97465 7.58219 6.75616C7.58409 6.53766 7.50009 6.32716 7.34829 6.16999ZM9.99996 4.58332C9.77895 4.58332 9.56698 4.67112 9.4107 4.8274C9.25442 4.98368 9.16663 5.19564 9.16663 5.41666C9.16663 5.63767 9.25442 5.84963 9.4107 6.00591C9.56698 6.16219 9.77895 6.24999 9.99996 6.24999C10.221 6.24999 10.4329 6.16219 10.5892 6.00591C10.7455 5.84963 10.8333 5.63767 10.8333 5.41666C10.8333 5.19564 10.7455 4.98368 10.5892 4.8274C10.4329 4.67112 10.221 4.58332 9.99996 4.58332Z"
            fill="#FF5C54"
          />
        <defs>
          <clipPath id="clip0_146_3998">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0.0374222 0.686157)"
            />
          </clipPath>
        </defs>
      </svg>
      <p class="cap">For Community Managers</p>
      </button>
      <h2 class="text-md text-black text-[20px] sm:text-[28px] md:text-[38px] lg:text-[40px] mb-0">
        Community Mobile App
      </h2>
      <p class="text-[#404653] font-[400] md:text-[16px] mb-8 text-[12px] my-2">
        Buatlah komunitas Anda lebih dekat dengan anggota melalui aplikasi mobile yang eksklusif. Nikmati beragam fitur menarik.
      </p>
      <ul class="list-none">
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_146_3603)">
              <path
              d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Branded App
          </span>
        </li>
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_146_3603)">
                <path
                d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                  fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Cross-Platform
          </span>
        </li>
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_146_3603)">
                <path
                d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                  fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Virtual Card
          </span>
        </li>
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_146_3603)">
                <path
                d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                  fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Push Notifications
          </span>
        </li>
      </ul>
    </div>
    <div class="flex md:hidden flex-col justify-center items-center">
      <Lazy height={300}>
        <picture>
          <img
            sizes="(max-width: 1400px) 100vw, 1400px"
            srcset="features1_fq0pyu_c_scale,w_1400.png"
            src="features1_fq0pyu_c_scale,w_1400.png"
            alt="Gambar"
            class="object-contain community-object xl:max-w-[670px] lg::max-w-[472px] h-[32rem] lg:py-12"
            width="697px"
            height="596px"
            loading="eager"
          />
        </picture>
      </Lazy>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 my-24 lg:my-32">
    <div class="flex flex-col justify-center"
    style="margin-left: 2rem">
      <button
        class="btn btn-info btn-sm md:btn-md mb-5 w-[14rem] md:w-66 gap-2 font-[500] text-primary">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="18" 
          height="18" 
          viewBox="0 0 18 18" 
          fill="none">
          <path d="M9.00002 0.666656C13.6025 0.666656 17.3334 4.39749 17.3334 8.99999C17.3334 13.6025 13.6025 17.3333 9.00002 17.3333C4.39752 17.3333 0.666687 13.6025 0.666687 8.99999C0.666687 4.39749 4.39752 0.666656 9.00002 0.666656ZM12.3367 9.73166C12.0492 9.29416 11.8417 8.97916 11.0517 9.10416C9.56002 9.34082 9.39419 9.60166 9.32335 10.0317L9.30335 10.1617L9.28252 10.3C9.20169 10.8692 9.20419 11.0842 9.46585 11.3583C10.52 12.465 11.1517 13.2625 11.3434 13.7292C11.4367 13.9567 11.6767 14.6458 11.5117 15.3275C12.5232 14.9246 13.4236 14.2854 14.1375 13.4633C14.2292 13.1517 14.2959 12.7633 14.2959 12.2933V12.2058C14.2959 11.4375 14.2959 11.0867 13.7525 10.7758C13.5779 10.6768 13.3985 10.5864 13.215 10.505C12.9092 10.3658 12.7067 10.275 12.4334 9.87499C12.4004 9.82773 12.3681 9.77995 12.3367 9.73166ZM9.00002 2.19416C7.06919 2.19416 5.32502 2.99916 4.08669 4.29082C4.23419 4.39332 4.36252 4.53749 4.45085 4.73582C4.62085 5.11666 4.62085 5.50916 4.62085 5.85666C4.62085 6.12999 4.62085 6.38999 4.70835 6.57749C4.82835 6.83416 5.34669 6.94416 5.80419 7.03916C5.96835 7.07416 6.13669 7.10916 6.29002 7.15166C6.71169 7.26832 7.03835 7.64749 7.29919 7.95166C7.40752 8.07749 7.56835 8.26332 7.64919 8.30999C7.69085 8.27999 7.82502 8.13416 7.89085 7.89499C7.94252 7.71166 7.92752 7.54999 7.85335 7.46166C7.38669 6.91166 7.41252 5.85332 7.55669 5.46249C7.78335 4.84666 8.49169 4.89249 9.01002 4.92582C9.20335 4.93832 9.38502 4.95082 9.52169 4.93332C10.04 4.86832 10.2 4.07916 10.3125 3.92499C10.5559 3.59166 11.3009 3.08916 11.7625 2.77916C10.8929 2.39248 9.9517 2.19316 9.00002 2.19416Z" 
          fill="#FF5C54"/>
          <defs>
            <clipPath id="clip0_146_3998">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0.0374222 0.686157)"
              />
            </clipPath>
          </defs>
        </svg>
        <p class="cap">For Public and Members</p>
      </button>
      <h2 class="text-md text-black text-[20px] sm:text-[28px] md:text-[38px] lg:text-[40px] mb-0">
        Community Website
      </h2>
      <p class="text-[#404653] font-[400] md:text-[16px] mb-8 text-[12px] my-2">
        Tampilkan komunitas Anda dengan bangga melalui situs web yang:
      </p>
      <ul class="list-none">
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_146_3603)">
                <path
                d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                  fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Mobile-friendly
          </span>
        </li>
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_146_3603)">
                <path
                d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                  fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Captivating Design
          </span>
        </li>
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_146_3603)">
                <path
                d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                  fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Custom Domain
          </span>
        </li>
      </ul>
    </div>
    <div class="flex flex-col justify-center items-center">
      <Lazy height={300}>
        <picture>
          <img
            sizes="(max-width: 1400px) 100vw, 1400px"
            srcset="
          features3_j7exjo_c_scale,w_1400.png 1400w"
            src="features3_j7exjo_c_scale,w_1400.png"
            alt="Gambar"
            class="object-contain xl:max-w-[670px] lg::max-w-[472px] lg:px-8"
            width="697px"
            height="596px"
            loading="eager"
          />
        </picture>
      </Lazy>
    </div>
  </div>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
    <div class="hidden md:flex flex-col justify-center items-center">
      <Lazy height={300}>
        <picture>
          <img
            sizes="(max-width: 1450px) 100vw, 1400px"
            srcset="features-4_j7exjo_c_scale,w_1400.png 1400w"
            src="features-4_j7exjo_c_scale,w_1400.png"
            alt="Gambar"
            class="object-contain xl:max-w-[670px] lg::max-w-[472px]"
            width="697px"
            height="596px"
            loading="eager"
          />
        </picture>
      </Lazy>
    </div>
    <div class="flex flex-col justify-center"
    style="margin-left: 2rem">
      <button
        class="btn btn-info btn-sm md:btn-md mb-5 w-[10rem] md:w-[10rem] gap-2 font-[500] text-primary">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_146_4401)">
            <path
              d="M4.99996 1.66663H15C15.221 1.66663 15.4329 1.75442 15.5892 1.9107C15.7455 2.06698 15.8333 2.27895 15.8333 2.49996V17.5C15.8333 17.721 15.7455 17.9329 15.5892 18.0892C15.4329 18.2455 15.221 18.3333 15 18.3333H4.99996C4.77895 18.3333 4.56698 18.2455 4.4107 18.0892C4.25442 17.9329 4.16663 17.721 4.16663 17.5V2.49996C4.16663 2.27895 4.25442 2.06698 4.4107 1.9107C4.56698 1.75442 4.77895 1.66663 4.99996 1.66663ZM9.99996 14.1666C9.77895 14.1666 9.56698 14.2544 9.4107 14.4107C9.25442 14.567 9.16663 14.7789 9.16663 15C9.16663 15.221 9.25442 15.4329 9.4107 15.5892C9.56698 15.7455 9.77895 15.8333 9.99996 15.8333C10.221 15.8333 10.4329 15.7455 10.5892 15.5892C10.7455 15.4329 10.8333 15.221 10.8333 15C10.8333 14.7789 10.7455 14.567 10.5892 14.4107C10.4329 14.2544 10.221 14.1666 9.99996 14.1666Z"
              fill="#FF5C54"
            />
          </g>
          <defs>
            <clipPath id="clip0_146_4401">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0.183472 0.7229)"
              />
            </clipPath>
          </defs>
        </svg>
        <p class="cap">For Members</p>
      </button>
      <h2 class="text-md text-black text-[20px] sm:text-[28px] md:text-[38px] lg:text-[40px] mb-0">
        Admin Dashboard
      </h2>
      <p class="text-[#404653] font-[400] md:text-[16px] mb-8 text-[12px] my-2">
        Kendalikan komunitas Anda dengan mudah melalui dashboard yang lengkap:
      </p>
      <ul class="list-none">
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_146_3603)">
                <path
                d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                  fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Kelola Anggota
          </span>
        </li>
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_146_3603)">
                <path
                d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                  fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Kelola Konten
          </span>
        </li>
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_146_3603)">
                <path
                d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                  fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Kelola Pengumuman
          </span>
        </li>
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_146_3603)">
                <path
                d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                  fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Kelola Pembayaran
          </span>
        </li>
        <li class="flex items-center mb-4">
          <span class="mr-2">
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_146_3603)">
                <path
                d="M6.16661 8.90583L14.5935 0.480743L15.8897 1.77691L6.16753 11.4991L0.333862 5.66541L1.63003 4.36924L6.16753 8.90674L6.16661 8.90583Z"                  fill="#FF5C54"
                />
              </g>
              <defs>
                <clipPath id="clip0_146_3603">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.0736694 0.758072)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <span class="text-[#70747E] font-[400] text-[18px] text-sm">
            Mobile App (Coming Soon)
          </span>
        </li>
      </ul>
    </div>
    <div class="flex md:hidden flex-col justify-center items-center">
      <Lazy height={300}>
        <picture>
          <img
            sizes="(max-width: 1450px) 100vw, 1400px"
            srcset="
          features-4_j7exjo_c_scale,w_1400.png 1400w"
            src="features-4_j7exjo_c_scale,w_1400.png"
            alt="Gambar"
            class="object-contain xl:max-w-[670px] lg::max-w-[462px] px-4"
            width="707px"
            height="606px"
            loading="eager"
          />
        </picture>
      </Lazy>
    </div>
  </div>

</div>

<style>
     .cap   { 
      text-transform: capitalize; 
      }
</style>